import { TFunction } from 'i18next';

import { HTTP_RESPONSE_STATUS } from 'shared/api/manage-onboarding-invites';

export const ACCEPTED_INVITE_ALERT_CLOSE_TIMEOUT = 6000;

type getAcceptedInviteMessagesProps = (
  t: TFunction<'translation', undefined>,
) => Record<string, string>;

export const getAcceptedInviteMessages: getAcceptedInviteMessagesProps = (
  t: TFunction<'translation', undefined>,
) => ({
  [HTTP_RESPONSE_STATUS.CREATED]: t('You have successfully joined Amplify'),
  [HTTP_RESPONSE_STATUS.BAD_REQUEST]: t(
    'Invite expired. Please contact your administrator.',
  ),
  [HTTP_RESPONSE_STATUS.NOT_FOUND]: t(
    'Error: Please contact Amplify at help@amplify.com',
  ),
  [HTTP_RESPONSE_STATUS.INTERNAL_SERVER_ERROR]: t(
    'Error: Please contact Amplify at help@amplify.com',
  ),
});

export const ORG_ID_SEARCH_PARAM = 'orgId';
